import { render, staticRenderFns } from "./idUserDataCustomField.vue?vue&type=template&id=442059f0&"
import script from "./idUserDataCustomField.vue?vue&type=script&lang=js&"
export * from "./idUserDataCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports